module.exports = __webpack_public_path__ + "img/yeji.658bc74c.png";